module.exports = __webpack_public_path__ + "img/plan-2-b6.c0953e91.png";